<div class="project-card">

  <div class="project-image" [ngStyle]="{'background-image': events.image, 'opacity': generalOpacity}" >
  </div>

  <div class="project-wrapper">
    <div class="event-checkin" *ngIf="hasCheckin" [ngStyle]="{ 'background-color': events.color }"></div>
    <div class="project-info" [ngStyle]="{ 'opacity': infoOpacity}">
      <h3 class="project-title">{{ events.name }}</h3>
      <div class="project-header">
      <ng-container >
        <span class="project-user">{{ events.address }}</span>
      </ng-container>
        <span class="tag electric">
        </span>
      </div>
      <div class="project-views">
        <span class="heart-container">
          {{events.date | date: 'dd/MM/yyyy'}}
        </span>
      </div>
      <div class="project-buttons">
        <p-button *ngIf="!showQRCode" severity="danger" (click)="checkIn()" [label]="'events.checkInBtn' | transloco" [ngStyle]="{ 'opacity': buttonsOpacity}" [disabled]="disableButtons"><i class="pi pi-map-marker"></i></p-button>
        <p-button *ngIf="showQRCode" severity="danger" (click)="onShowQRCode()" [label]="'events.viewQRCode' | transloco" [ngStyle]="{ 'opacity': buttonsOpacity}" [disabled]="disableButtons"><i class="pi pi-qrcode"></i></p-button>
        <!-- <p-button severity="danger" label="Informações do Evento" [ngStyle]="{ 'opacity': infoOpacity}"><i class="pi pi-info-circle"></i></p-button> -->
        <div class="button-wrapper"  [ngStyle]="{ 'opacity': buttonsOpacity}" >
          <div class="button-inner">
            <p-button id="btnBack" name="btnBack" [label]="'events.eventInfo' | transloco" (click)="getInfoEvent()" [raised]="true" [disabled]="disableButtons"
              styleClass="custom-button"><i class="pi pi-info-circle" style="margin-right: 5px;"></i></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog />